/**
 * Expandable Author Bio
 *
 * Adds "Read more/Read less" functionality to WordPress Author block bios
 * when the content exceeds the minimum character length.
 * The minimum length is set in PHP via the qala_theme/filter/post_author_bio_min_length filter
 * and passed to the JS via the data-qala-bio-min-length attribute.
 */

document.addEventListener( 'DOMContentLoaded', () => {
	const authorBios = document.querySelectorAll( '.wp-block-post-author__bio' );

	if ( authorBios.length === 0 ) {
		return;
	}

	// Check if text needs to be expandable or not.
	authorBios.forEach( bio => {
		const button = bio.nextElementSibling;

		// Return early if button doesn't exist or isn't the expand button.
		if ( ! button || ! button.classList.contains( 'wp-block-post-author__btn' ) ) {
			return;
		}

		// Read the minimum length from the data attribute set by PHP.
		// Falls back to 120 if the attribute is missing for any reason.
		const minBioLength = parseInt( bio.dataset.qalaBioMinLength, 10 ) || 120;

		// Get the text content and check length.
		const bioText = bio.textContent || bio.innerText || '';
		const bioLength = bioText.trim().length;

		if ( bioLength > minBioLength ) {
			// Content exceeds minimum length, keep button visible and add click handler.
			button.addEventListener( 'click', () => {
				const isExpanded = button.getAttribute( 'aria-expanded' ) === 'true';
				button.setAttribute( 'aria-expanded', isExpanded ? 'false' : 'true' );
			} );
		} else {
			// Content is short enough, hide button.
			button.style.display = 'none';
		}
	} );
} );
